jQuery(($) => {
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Browser - Keydown Focus Class
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $("body").on("keydown", function () {
    if (!$(".keyboard-in-use")[0]) {
      $(this).addClass("keyboard-in-use");
    }
  });

  $("body").on("mousedown", function () {
    if ($(".keyboard-in-use")[0]) {
      $(this).removeClass("keyboard-in-use");
    }
  });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Browser: Animate Scroll to Anchor Link
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
 
      $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('[href="#content"]').click(function (e) {
          if (
              location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
              location.hostname == this.hostname
          ) {
              let target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

              if (target.length) {
                  e.preventDefault();

                  const targetTop = target.offset().top - 50;

                  $('html, body').animate({
                      scrollTop: targetTop > 0 ? targetTop : 0
                  }, 600);
              }
          }
      });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _Header
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟StickyNav
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    $(window).on('load scroll', function () {
        var distance = $(window).scrollTop();

        if (distance > 25) {
            $('.o-header').addClass('o-header--sticky');
        } else {
            $('.o-header').removeClass('o-header--sticky');
        }
        if (distance > 25) {
            $('.o-header').addClass('o-header--mobile');
        } else {
            $('.o-header').removeClass('o-header--mobile');
        }
        if (distance > 5) {
            $('.o-header').addClass('o-header--small');
        } else {
            $('.o-header').removeClass('o-header--small');
        }
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Header
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟MenuToggle
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    $('.o-header__hamburger').click(function () {
        if ($('.o-header--open')[0]) {
            $('body').removeAttr('style');
        } else {
            $('body').css('overflow', 'hidden');
        }

        $(this).toggleClass('a-hamburger--toggled');
        $('.o-header').toggleClass('o-header--open');
        $('.o-header__navigation-outer').toggleClass('o-header__navigation-outer--open');
    });

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Accessibility
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    if ($('.o-header__hamburger')[0]) {
        // On Toggle Keydown
        $('.o-header__hamburger').keydown(function (e) {

            if (e.key === 'Enter') {
                e.preventDefault();

                $('.o-header__wrapper').toggleClass('o-header__wrapper--open');

                if ($('.o-header__wrapper').hasClass('o-header__wrapper--open')) {
                    $('.o-header .m-page-nav__list').attr('aria-expanded', 'true');
                    $(this).attr('aria-pressed', 'true');
                    $(this).addClass('a-hamburger--toggled');
                    $('body').css('overflow', 'hidden');

                } else {
                    $('.o-header .m-page-nav__list').attr('aria-expanded', 'false');
                    $(this).attr('aria-pressed', 'false');
                    $(this).removeClass('a-hamburger--toggled');
                    $('body').removeAttr('style');
                }

                setTimeout(function () {
                    list.find("li:first-child a").focus();
                }, 0);
            }
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ CaptionedImagesSlider
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if ($('.o-captioned-images-slider')[0]) {
        $('.o-captioned-images-slider').each(function () {
            var arrowsNav = $(this).find('.o-captioned-images-slider__arrows'),
                dotsNav   = $(this).find('.o-captioned-images-slider__dots'),
                slides    = $(this).find('.o-captioned-images-slider__slides');

            slides.slick({
                speed: 550,
                slidesToShow: 3,
                slidesToScroll: 1,
                appendArrows: arrowsNav,
                appendDots: dotsNav,
                dots: true,
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]
            });
        });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ GallerySlider
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if ($('.o-gallery-slider')[0]) {
        $('.o-gallery-slider--init').each(function () {
            var arrowsNav = $(this).find('.o-gallery-slider__arrows'),
                dotsNav   = $(this).find('.o-gallery-slider__dots'),
                slides    = $(this).find('.o-gallery-slider__slides');

            slides.slick({
                speed: 550,
                slidesToShow: 3,
                slidesToScroll: 1,
                appendArrows: arrowsNav,
                appendDots: dotsNav,
                dots: true,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                    }
                }]
            });
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Google Translate Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if (localStorage.getItem('languageState') != 'spanish') {
        $('.o-notification-bar').css('display', 'block');

        $('.o-header').addClass('o-header--notification');
    }

    $(window).on('load', function(){
        if (localStorage.getItem('languageState') == 'spanish') {
            if ($('.js-translate-spanish').css('display', 'flex')) {
                $('.js-translate-spanish').css('display', 'none');
            }

            if ($('.js-translate-english').css('display', 'none')) {
                $('.js-translate-english').css('display', 'flex');
            }

        }
    });


    $(window).on('switchLanguage', function(){
        var lang = $('html').attr('lang');

        if (lang == 'es') {
            $('.js-translate-spanish').css('display', 'none');
            $('.js-translate-english').css('display', 'flex');
        } else {
            $('.js-translate-english').css('display', 'none');
            $('.js-translate-spanish').css('display', 'flex');
        }
    });

    $('.js-gt-link').click(function(){
        setTimeout(function () {
            $(window).trigger('switchLanguage')(lang_pair);
        }, 300);

        if (localStorage.getItem('languageState') != 'spanish') {
            localStorage.setItem('languageState', 'spanish');
        } else {
            localStorage.setItem('languageState', 'english');
        }
    });
});
